import PropTypes from 'prop-types';
import * as React from 'react';
import type ColumnSynchronizer from './ColumnSynchronizer';
import DataTableHeaderRow from './DataTableHeaderRow';
import type {ColumnPropType} from './propTypes';
import {columnPropType, columnSynchronizerPropType} from './propTypes';

export type Props = {
    columns: ColumnPropType[],
    columnSynchronizer?: ColumnSynchronizer,
    paddingColumn?: boolean,
    rowProps?: Object,
    selected?: boolean,
    onSelectionChange?: (value: boolean, column: ColumnPropType) => void,
};

export default class DataTableHeader extends React.PureComponent<Props> {

    static propTypes = {
        columns: PropTypes.arrayOf(columnPropType).isRequired,
        columnSynchronizer: columnSynchronizerPropType,
        paddingColumn: PropTypes.bool,
        rowProps: PropTypes.object,
        selected: PropTypes.bool,
        onSelectionChange: PropTypes.func,
    };

    props: Props;

    render(): React.ReactNode {
        const {
            columns,
            columnSynchronizer,
            paddingColumn,
            rowProps,
            selected,
            onSelectionChange,
            ...otherProps
        } = this.props;

        return (
            <thead {...otherProps}>
            <DataTableHeaderRow {...rowProps}
                                columns={columns}
                                columnSynchronizer={columnSynchronizer}
                                paddingColumn={paddingColumn}
                                selected={selected}
                                onSelectionChange={onSelectionChange}/>
            </thead>
        );
    }

}
